(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("gyrejs-main", [], factory);
	else if(typeof exports === 'object')
		exports["gyrejs-main"] = factory();
	else
		root["gyrejs-main"] = factory();
})(this, function() {
return 